import { DateTime } from 'luxon';
import type { TProjectVersion } from '@newo/api/gateway';

export const formatVersionLabel = (
    version: Pick<TProjectVersion, 'version_prefix' | 'version_increment'>
): string => `${version.version_increment}: ${version.version_prefix}`;

export const formatRelative = (iso: string): string =>
    DateTime.fromISO(iso).toRelative() ?? '—';
